import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({ onScrollToGenerator }) => {
  return (
    <div className="bg-gradient-to-b from-pink-50 to-white py-20 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <Badge className="mb-4 bg-pink-100 text-pink-700 hover:bg-pink-200">
          🏥 Free Medical Certificate Tool
        </Badge>
        
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 tracking-tight">
          Medical Certificate Generator — Free Handwritten Style PDF &amp; PNG (India)
        </h1>
        
        <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
          Create professional doctor certificates, sick leave certificates & medical fitness certificates instantly. 
          Download as PDF or print — 100% free, no signup required.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button 
            size="lg" 
            className="bg-pink-600 hover:bg-pink-700 text-white px-8 py-6 text-lg"
            onClick={onScrollToGenerator}
          >
            Generate Certificate Free
          </Button>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-pink-600 mb-2">50,000+</div>
            <div className="text-sm text-gray-600">Certificates Generated</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-pink-600 mb-2">100%</div>
            <div className="text-sm text-gray-600">Free Forever</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-pink-600 mb-2">🔒</div>
            <div className="text-sm text-gray-600">Privacy First</div>
          </div>
        </div>
        
        {/* Real Certificate Consultation Banner */}
        <div className="mt-12 max-w-4xl mx-auto bg-gradient-to-r from-pink-600 to-pink-700 rounded-2xl p-8 text-white shadow-2xl">
          <div className="flex items-center gap-6">
            <div className="flex-shrink-0">
              <div className="bg-white rounded-full p-4">
                <svg className="w-12 h-12 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold mb-2">Need a Real, Verified Medical Certificate?</h3>
              <p className="text-pink-100 mb-4">
                Consult with licensed doctors online and get a valid medical certificate that can be verified by employers and institutions.
              </p>
              <a 
                href="https://easymedicalcertificate.in/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-white text-pink-600 font-bold px-8 py-3 rounded-lg hover:bg-pink-50 transition-colors shadow-lg"
              >
                Get Verified Certificate →
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-12 max-w-3xl mx-auto bg-yellow-50 border-l-4 border-yellow-400 p-6 text-left">
          <p className="text-sm font-semibold text-gray-800 mb-2">⚠️ Important Disclaimer:</p>
          <p className="text-sm text-gray-700">
            This tool generates <strong>templates only</strong> and is intended for clinics, doctors, students (draft purposes), 
            and HR documentation. <strong>This is not a valid medical certificate without doctor verification, signature, 
            and official stamp/seal.</strong> Do NOT use generated certificates to misrepresent medical conditions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;